import { autoinject, transient } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { PortCallStatusModel } from "../../../models/ports-and-terminals.models";
import { PortsAndTerminalsService } from "../../../services/ports-and-terminals.service";
import { computedFrom } from "aurelia-binding";
import { Reflection } from "../../../../../../../utilities/reflection";

@autoinject
@transient()
export class VesselPreArrivalStatusDialog {
    constructor(private dialogClientService: DialogClientService,
        private portsAndTerminalsService: PortsAndTerminalsService) {
    }

    setStatus: any;
    vesselPortCallId: number;
    comments: string;
    reload: (() => void);
    isDropdownOpen: boolean;
    statusId: number;
    statuses: PortCallStatusModel[];
    currentStatus: PortCallStatusModel;
    misreportedReasonId: number;
    vesselName: string;
    internationalMaritimeOrganizationNumber: string;
    europeanNumberOfIdentification: string;
    vehicleIdentificationNumber: string;

    async activate(model) {
        this.reload = model.reload;
        this.vesselPortCallId = model.vesselPortCallId;
        this.statusId = model.statusId;
        this.setStatus = model.setStatus;
        this.vesselName = model.vesselName;
        this.internationalMaritimeOrganizationNumber = model.internationalMaritimeOrganizationNumber;
        this.europeanNumberOfIdentification = model.europeanNumberOfIdentification;
        this.vehicleIdentificationNumber = model.vehicleIdentificationNumber;

        const statuses = await this.portsAndTerminalsService.loadPortCallStatus();
        this.currentStatus = statuses.filter(x => x.statusId == this.statusId)[0];
        this.statuses = statuses.filter(x => !x.isSystemStatus);
    }

    @computedFrom(Reflection.getPropertyPath<VesselPreArrivalStatusDialog>(z =>z.currentStatus),
    Reflection.getPropertyPath<VesselPreArrivalStatusDialog>(z =>z.statusId),
    Reflection.getPropertyPath<VesselPreArrivalStatusDialog>(z =>z.currentStatus.statusId))
    get submitEnabled(): boolean {
        return this.currentStatus && this.statusId != this.currentStatus.statusId;
    }

    openDropdown(event) {
        event.stopPropagation();
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    closeDropdown() {
        this.isDropdownOpen = false;
    }

    changeStatus(value: PortCallStatusModel) {
        this.currentStatus = value;
    }

    cancel() {
        this.dialogClientService.hide();
    }

    async submit() {
        try {
            await this.portsAndTerminalsService.changeVesselPortCallStatus(this.vesselPortCallId, this.currentStatus.statusId, this.comments);

            if (this.reload)
                this.reload();
            this.dialogClientService.hide();
        } catch (e) {
            console.error("Failed to submit vessel-pre-arrival status change", e);
        }
    }

    public commentsLabel: string = "Comments";
    
    lastSelectedItemIds: number[] = [];

    selectedItemsChanged($event) {
        const notSelected = $event.detail.filter(x => !x.isSelected);

        if (this.comments) {
            notSelected.forEach(x => {
                const index = this.lastSelectedItemIds.indexOf(x.id);
                if (index >= 0)
                    this.lastSelectedItemIds.splice(index, 1);
                this.comments = this.comments.split(`, ${x.name}`).join("");
                this.comments = this.comments.split(`${x.name}, `).join("");
                this.comments = this.comments.split(x.name).join("");
            });
        }

        const newItems = $event.detail.filter(x => x.isSelected && this.lastSelectedItemIds.indexOf(x.id) == -1);
        newItems.forEach(x => {
            if (this.comments && !this.comments.endsWith(", "))
                this.comments += ", ";
            else if (!this.comments) {
                this.comments = "";
            }

            if (x && x.name)
                this.comments += x.name;

            this.lastSelectedItemIds.push(x.id);
        });
    }

    getPortCallStatusClass(status: PortCallStatusModel) {
        if (status.statusName) {
            return status.statusName == 'Reviewed (with warnings)' ? 'reviewed-with-warnings' : status.statusName.split(' ').join('-').toLowerCase();
        }
    }
}